import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import SubMenuFields from './SubMenuFields'

export const SubMenuEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <SubMenuFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default SubMenuEdit
